module.exports = __webpack_public_path__ + "img/angststoerungen1_1920.b25f86b3.png";